<template>
  <v-row class="white pt-3 px-3 mb-3" no-gutters>
    <v-col sm="4" cols="12" class="d-flex justify-space-between">
      <v-text-field
        :label="$t(`labels.search_text`)"
        v-model="query.name"
        @keypress.enter="handleSearch"
        dense
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4">
      <v-radio-group
        v-model="query.visible"
        @change="handleVisibility"
        row
        class="ma-2 mx-4"
      >
        <v-radio :label="$t('table.invisible')" :value="false"></v-radio>
        <v-radio :label="$t('table.visible')" :value="true"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12" sm="4">
      <v-btn color="primary" class="mx-4" @click="handleSearch">{{
        $t("button.search")
      }}</v-btn>
      <v-btn color="error" @click="handleClear">{{ $t("button.clear") }}</v-btn>
    </v-col>
  </v-row>
</template>

<script>
const defaultQuery = {
  name: "",
  page: 1
};
export default {
  data() {
    return {
      query: {
        ...defaultQuery
      },
      visible: 0
    };
  },
  created() {
    this.setValuesFromUrl();
  },
  methods: {
    handleSearch() {
      if (this.query.name !== "") {
        this.$router.push({ query: this.query });
      }
    },
    handleVisibility(value) {
      this.$router.push({ query: { visible: value } });
    },
    handleClear() {
      this.query = defaultQuery;
      this.$router.push({ query: { page: 1 } });
    },
    setValuesFromUrl() {
      this.query.name = this.$route.query.name || "";
      this.visible = this.$route.query.visible || 0;
    }
  }
};
</script>

<style lang="scss" scoped></style>
